import _ from 'lodash'
import moment from 'moment'

const hanleItinerarys = (detail, ifInternational) => {
  const _detail = _.cloneDeep(detail)
  return _detail.itinerarys.map(itinerary => {
    // 划分品牌等级(cabin)
    const cabins = []
    const cabinGroup = _.groupBy(itinerary.productPrices, item => {
      return item.detail.services[0].levelCode
    })
    const tripType = itinerary.itineraryType
    for (const cabinGroupKey in cabinGroup) {
      // 划分品牌(band)
      const brands = []
      const brandGroup = _.groupBy(cabinGroup[cabinGroupKey], item => {
        return item.detail.services[0].prodCabinCode
      })
      for (const brandGroupKey in brandGroup) {
        // 产品舱位(product)
        const productsGroup = _.cloneDeep(brandGroup[brandGroupKey])
        const products = []
        for (const product of productsGroup) {
          const { detail } = product
          const fareDetails = ifInternational ? detail.sumFareDetails : (detail.services[0].fareDetails || [])
          const { fares = [], taxes = [] } = fareDetails.find(item => { return item.fareType === 'ADT' })
          // const fares = fareDetails.find(item => { return item.fareType === 'ADT' }).fares || []
          // 设置默认(最低)价格(default price) & 税费(合计) (tax)
          const defaultFare = product.detail.services[0].defaultFare = _.minBy(fares, item => item.amount)
          const defaultTax = product.detail.services[0].defaultTax = _.sumBy(taxes, item => item.amount)
          product.detail.services[0].defaultFareIncludeTax = _.sum([defaultFare?.amount, defaultTax])
          if (tripType === 'CT') {
            product.detail.services[0].defaultFare = {
              amount: product.detail.totalItineraryFare
            }
          }
          // 划分标签价格(tag price)[国际航班暂时不支持]
          if (fares.length > 0 && !ifInternational) {
            for (const fare of fares) {
              const cloneProduct = _.cloneDeep(product)
              cloneProduct.detail.services[0].fareDetails.find(item => { return item.fareType === 'ADT' }).fares = [{ ...fare }]
              products.push(cloneProduct)
            }
          } else {
            products.push(product)
          }
        }
        brands.push({
          products
        })
      }

      // 选取默认产品获取品牌信息
      const defaultProduct = cabinGroup[cabinGroupKey][0].detail.services[0]

      cabins.push({
        cabinLevel: defaultProduct.levelCode,
        cabinName: defaultProduct.levelName,
        disabled: !(cabinGroup[cabinGroupKey].length > 0),
        brands
      })
    }
    // 保留 className 用于兼容旧版的部分逻辑
    itinerary.productPrices.forEach((product, idx) => {
      if (product.type.toLocaleLowerCase() === 'ticket') {
        product.index = idx
        product.className = cabins.find(item => item.cabinLevel === product.detail.services[0].levelCode).cabinLevel
      }
    })
    // 中转概览
    if (itinerary.orgDsts?.length > 1) {
      Object.assign(itinerary, handleTransit(itinerary))
    }
    return {
      ...itinerary,
      cabins
    }
  })
}

const handleTransit = (itinerary) => {
  const _itinerary = _.cloneDeep(itinerary)
  const orgDsts = _.cloneDeep(_itinerary.orgDsts)
  const orgDstTotal = {
    departureCode: _.head(orgDsts)?.departureCode,
    departureName: _.head(orgDsts)?.departureName,
    departureDate: _.head(orgDsts)?.departureDate,
    departureTime: _.head(orgDsts)?.departureTime,
    departureTerminal: _.head(orgDsts)?.departureTerminal,
    departureAirPortName: _.head(orgDsts)?.departureAirPortName,
    arrivalCode: _.last(orgDsts)?.arrivalCode,
    arrivalName: _.last(orgDsts)?.arrivalName,
    arrivalAirPortName: _.last(orgDsts)?.arrivalAirPortName,
    arrivalTerminal: _.last(orgDsts)?.arrivalTerminal,
    arrivalDate: _.last(orgDsts)?.arrivalDate,
    arrivalTime: _.last(orgDsts)?.arrivalTime
  }
  orgDstTotal.flightInfos = []
  orgDstTotal.IATAGroup = []
  orgDstTotal.airlineCodeGroup = []
  orgDstTotal.flightNoGroup = []
  for (let index = 0; index < orgDsts.length; index++) {
    const orgDst = orgDsts[index]
    orgDstTotal.flightInfos.push({
      flightNo: orgDst.flightNo,
      airlineCode: orgDst.airlineCode,
      airlineName: orgDst.airlineName,
      belongGroup: orgDst.belongGroup,
      aircraftCode: orgDst.aircraftCode,
      stopCitys: orgDst.stopCitys,
      stopQuantity: orgDst.stopQuantity,
      codeShare: orgDst.codeShare, // 用途不明
      duration: orgDst.duration
    })
    if (index === 0) {
      orgDstTotal.IATAGroup.push(orgDst.departureCode)
    }
    orgDstTotal.IATAGroup.push(orgDst.arrivalCode)
    orgDstTotal.airlineCodeGroup.push(orgDst.airlineCode)
    orgDstTotal.flightNoGroup.push(orgDst.flightNo)
    if (orgDsts[index + 1]) {
      orgDsts[index].transferDuration = {
        departureDate: orgDst.arrivalDate,
        departureTime: orgDst.arrivalTime,
        arrivalDate: orgDsts[index + 1]?.departureDate,
        arrivalTime: orgDsts[index + 1]?.departureTime
      }
      orgDstTotal.transferDuration = orgDsts[index].transferDuration
    }
  }
  _itinerary.isTransfer = true
  _itinerary.orgDstTotal = orgDstTotal
  _itinerary.orgDsts = orgDsts

  return _itinerary
}

const sortItinerarys = (list, sortType, airline, priceKey = 'brands[0].products[0].detail.totalItineraryFare') => {
  // 按sortType进行排序
  if (sortType !== 'default') {
    if (sortType === 'priceAsc') {
      list = list.sort(function (a, b) {
        const aitem = a.cabins.find(item => { return item.cabinLevel.indexOf('ECOM_LEVEL') >= 0 })
        const bitem = b.cabins.find(item => { return item.cabinLevel.indexOf('ECOM_LEVEL') >= 0 })
        const aPrice = _.get(aitem, priceKey) || Infinity
        const bPrice = _.get(bitem, priceKey) || Infinity
        return aPrice - bPrice
      })
    } else if (sortType === 'priceDesc') {
      list = list.sort(function (a, b) {
        const aitem = a.cabins.find(item => { return item.cabinLevel.indexOf('ECOM_LEVEL') >= 0 })
        const bitem = b.cabins.find(item => { return item.cabinLevel.indexOf('ECOM_LEVEL') >= 0 })
        const aPrice = _.get(aitem, priceKey) || Infinity
        const bPrice = _.get(bitem, priceKey) || Infinity
        return bPrice - aPrice
      })
    } else if (sortType === 'dateAsc') {
      list = list.sort(function (a, b) {
        const aTime = moment(`${a.orgDsts[0].departureDate} ${a.orgDsts[0].departureTime}`).valueOf()
        const bTime = moment(`${b.orgDsts[0].departureDate} ${b.orgDsts[0].departureTime}`).valueOf()
        return aTime - bTime
      })
    } else if (sortType === 'dateDesc') {
      list = list.sort(function (a, b) {
        const aTime = moment(`${a.orgDsts[0].departureDate} ${a.orgDsts[0].departureTime}`).valueOf()
        const bTime = moment(`${b.orgDsts[0].departureDate} ${b.orgDsts[0].departureTime}`).valueOf()
        return bTime - aTime
      })
    }
  } else {
    // FU 直飞在前，互售在后，中转最后，按耗时排序
    if (airline === 'FU') {
      // // 使用 _.partition 和 _.sortBy 来优化
      // const [fuAirItineraries, otherAirItineraries] = _.partition(list, (item) => {
      //   return item.orgDsts?.[0]?.supplierCode === 'FU' && item.itineraryType !== 'CT'
      // })
      // 修复条件存在分组交集的问题
      const fuAirItineraries = _.filter(list, (item) => item.orgDsts?.[0]?.supplierCode === 'FU' && item.itineraryType !== 'CT')
      const otherAirItineraries = _.filter(list, (item) => item.orgDsts?.[0]?.supplierCode !== 'FU' && item.itineraryType !== 'CT')
      const transferAirItineraries = _.filter(list, (item) => item.itineraryType === 'CT')

      // 使用 _.sortBy 来排序
      const sortAirItineraries = (itineraries) => {
        return _.sortBy(itineraries, (item) => {
          // 获取最后一个目的地的到达时间
          const lastDestination = item.orgDsts[item.orgDsts.length - 1]
          const arrivalTime = moment(`${lastDestination.arrivalDate} ${lastDestination.arrivalTime}`).valueOf()

          // 获取第一个目的地的出发时间
          const firstDestination = item.orgDsts[0]
          const departureTime = moment(`${firstDestination.departureDate} ${firstDestination.departureTime}`).valueOf()

          // 计算全程时间
          const totalTime = arrivalTime - departureTime

          return totalTime
        })
      }

      const sortedFuAirItineraries = sortAirItineraries(fuAirItineraries)
      const sortedOtherAirItineraries = sortAirItineraries(otherAirItineraries)
      const sortedTransferAirItineraries = sortAirItineraries(transferAirItineraries)

      // 合并数组
      list = sortedFuAirItineraries.concat(sortedOtherAirItineraries, sortedTransferAirItineraries)
    }
  }

  // NOTE: JD 个性化排序
  if (airline === 'JD' && sortType !== 'default') {
    // 排序规则，按先直飞，再中转
    const sortMap = {
      'OW': 1,
      'RT': 1,
      'CT': 2
    }
    list = _.sortBy(list, (item) => {
      return sortMap?.[item['itineraryType']]
    })
  }

  // NOTE: JD 个性化排序
  if (airline === 'JD' && sortType !== 'default') {
    // 排序规则，按先直飞，再中转
    const sortMap = {
      'OW': 1,
      'RT': 1,
      'CT': 2
    }
    list = _.sortBy(list, (item) => {
      return sortMap?.[item['itineraryType']]
    })
  }

  return list
}

export {
  hanleItinerarys,
  handleTransit,
  sortItinerarys
}
